import {io} from "socket.io-client";

export default function initializeSocket(signature) {
    const socket = io(import.meta.env.VITE_MACHINE_URL, {
        auth: {token: signature}
    });
    return socket;
}

